import { NGROK } from "../../../../APIs";
import { apiClient } from "../../../../utils/apiClient";

export const listSubNets = async (tenantName: string, computerId: string): Promise<SubnetResponse> => {
    const url = `${NGROK}/api/subnet/list-subnet`;
    const data = await apiClient({
        method: "GET",
        url,
        params: { id: computerId, tenantName: tenantName }
    });

    return data;
};


export const addSubnets = async (payload: any) => {
    const url = `${NGROK}/api/subnet/add-subnet`;
    const data = await apiClient({
        method: "POST",
        url,
        data: payload
    });

    return data;
};


export const deleteSubnets = async (payload: any) => {
    const url = `${NGROK}/api/subnet/remove-subnet`;
    const data = await apiClient({
        method: "POST",
        url,
        data: payload
    });

    return data;
};